import { useTranslation } from "react-i18next";

interface CrossBorderNoteProps {
  /** Whether the roaster's home region levies Kaffeesteuer — picks which explanatory note to show. */
  homeLeviesKs: boolean;
  testId?: string;
}

/**
 * Footer note under the cross-border pricing section. The wording depends on the
 * roaster's home region:
 * - Home levies KS (e.g. DE): destinations without coffee tax invoice lower.
 * - Home has no KS (e.g. NL): the wholesale price is unchanged across
 *   destinations because BRG lodges the Kaffeesteuer; only the RRP rises for
 *   KS destinations. Shared by the SKU import form and the price-update popover.
 */
export const CrossBorderNote = ({ homeLeviesKs, testId }: CrossBorderNoteProps) => {
  const { t } = useTranslation();
  const note = homeLeviesKs ? t("products.priceUpdate.crossBorder.noteHomeKs") : t("products.priceUpdate.crossBorder.noteHomeNoKs");

  return (
    <div
      className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-2.5 text-[11px] leading-relaxed text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-200"
      data-testid={testId}
    >
      <span aria-hidden="true">💡</span>
      <span>{note}</span>
    </div>
  );
};
